import React from 'react';
import { useNavigate } from 'react-router-dom';
import SystemHeader from './SystemHeader';

// Trang giữ chỗ cho tính năng chưa làm (15 Quy định công ty, 25 Vinh danh — 16 Kiến thức kinh doanh có combo từ 22/10/2026, 17 có mật khẩu, 24 có trang).
const DangTrienKhaiPage = ({ title, icon = 'construction', userInfo, onLogout, totalPoints, onRefreshPoints }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <SystemHeader userInfo={userInfo} onLogout={onLogout} totalPoints={totalPoints} pageTitle={title} onRefreshPoints={onRefreshPoints} />
      <div className="flex-1 flex flex-col items-center justify-center px-6 text-center gap-3">
        <div className="w-20 h-20 rounded-3xl bg-white border-2 border-dashed border-gray-300 flex items-center justify-center text-gray-400">
          <span className="material-symbols-rounded" style={{ fontSize: 40 }}>{icon}</span>
        </div>
        <h1 className="text-lg font-bold text-gray-800">{title}</h1>
        <span className="text-[12px] font-bold text-amber-800 bg-amber-100 rounded-full px-3 py-1">Đang triển khai</span>
        <p className="text-sm text-gray-500">Tính năng này đang được xây dựng, sẽ mở trong thời gian tới.</p>
        <button type="button" onClick={() => navigate('/dashboard')}
                className="mt-2 px-4 py-2 rounded-xl bg-[#1E5A35] text-white text-sm font-semibold active:scale-95 transition-transform">
          Về màn hình chính
        </button>
      </div>
    </div>
  );
};

export default DangTrienKhaiPage;
